// JOBE-0101: EntityBrowserContext — published by <EntityBrowser> so
// slot consumers (rail, header, inspector overrides) and the outer
// surface page (saved-views, omni palette) can read/dispatch the
// host's chip/sort/view/selection state without re-instantiating a
// duplicate URL-state hook (which would cause write-races).
//
// Surfaces that own their own state (the hook-only escape hatch path)
// don't use this context — they consume `useEntityBrowserState`
// directly. The host wires both internally so the common case is
// implicit.

import { createContext, useContext } from 'react';

export const EntityBrowserContext = createContext(null);

export function useEntityBrowserContext() {
  const ctx = useContext(EntityBrowserContext);
  if (!ctx) {
    throw new Error(
      'useEntityBrowserContext: no <EntityBrowser> ancestor. Components that '
        + 'compose against the host\'s state must be rendered inside the host\'s '
        + 'slot props (rail / header / inspector) or under a sibling wrapper '
        + 'that mounts EntityBrowserContext.Provider.',
    );
  }
  return ctx;
}
